import React from 'react';

const Close: React.FC<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> = props => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.424 6.424a.6.6 0 00-.848-.848L12 11.152 6.424 5.576a.6.6 0 00-.848.848L11.152 12l-5.576 5.576a.6.6 0 10.848.848L12 12.85l5.576 5.575a.6.6 0 00.848-.848L12.85 12l5.575-5.576z"
      fill="#5A6474"
    />
  </svg>
);

export default Close;
